import i18n from '@/localisation/i18n';

export const OurApp = () => {
  return (
    <a
      href="https://www.mind-health.app"
      target="_blank"
      className="relative h-56 w-full overflow-hidden rounded-lg bg-primary p-6 md:h-64 md:min-w-[330px] md:max-w-[430px]"
    >
      <h3 className="relative z-10 w-48 font-bold md:text-lg">
        {i18n.t('our.app')}
      </h3>
      <img
        className="absolute -bottom-10 right-0 md:bottom-0"
        width={200}
        height={220}
        src="/images/apps.png"
        alt="apps"
      />
      <img
        className="absolute bottom-0 left-0 w-72 md:w-[320px]"
        width={320}
        height={164}
        src="/images/stars.svg"
        alt="apps"
      />
    </a>
  );
};
